module.exports = __webpack_public_path__ + "img/DealerIcons-M1Build-Off.317bd69.jpg";